<template>
  <OurCard
    class="manager-analytics-card mb-4"
    :class="{ 'manager-analytics-card--total': isTotal }"
    border-radius="sm"
  >
    <div class="manager-analytics-card__title">{{ cardTitle }}</div>

    <div class="manager-analytics-card__metrics">
      <OurTextField
        v-for="field in fields"
        :key="field.key"
        :label="$t(field.labelKey)"
        class="manager-analytics-card__metric"
      >
        <span v-if="field.type === 'count'" class="metric-value">{{
          formatCount(item[field.key])
        }}</span>
        <span v-else-if="field.type === 'time'" class="metric-value">{{
          item[field.key] ?? "–"
        }}</span>
        <ManagerAnalyticsMetricCell v-else v-bind="getMetricCell(field, item)" />
      </OurTextField>
    </div>
  </OurCard>
</template>

<script>
import ManagerAnalyticsMetricCell from "./ManagerAnalyticsMetricCell.vue";
import {
  MANAGER_ANALYTICS_FIELDS,
  formatAnalyticsCount,
  formatCountMetricCell,
  formatOrdersSumCell,
  formatSumMetricCell,
} from "../config/analyticsCards.config";

const METRIC_FORMATTERS = {
  countMetric: formatCountMetricCell,
  ordersSum: formatOrdersSumCell,
  sumMetric: formatSumMetricCell,
};

export default {
  name: "ManagerAnalyticsCard",

  components: {
    ManagerAnalyticsMetricCell,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },

    title: {
      type: String,
      default: "",
    },

    isTotal: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fields: () => MANAGER_ANALYTICS_FIELDS,

    cardTitle() {
      return this.title || this.item.managerName;
    },
  },

  methods: {
    formatCount: formatAnalyticsCount,

    getMetricCell(field, item) {
      const formatter = METRIC_FORMATTERS[field.type];

      return formatter ? formatter(item[field.key]) : {};
    },
  },
};
</script>

<style lang="postcss" scoped>
.manager-analytics-card {
  &--total {
    @apply bg-gray-50;
  }

  &__title {
    @apply mb-4 text-base font-bold text-gray-900;
  }

  &__metrics {
    @apply grid grid-cols-2 gap-4 xl:grid-cols-4;
  }

  &__metric:deep(.text-field-value) {
    @apply mt-1;
  }

  .metric-value {
    @apply text-sm font-bold text-gray-900;
  }
}
</style>
